import { Loader2 } from "lucide-react";
import { Card } from "../../ui";
import { DateInput } from "../../DateInput";
import { Field, INPUT_CLS } from "./shared";

const TextField = ({ label, value, onChange, disabled, placeholder, testid, wide }) => (
  <div className={wide ? "md:col-span-2" : undefined}>
    <Field label={label}>
      <input
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled}
        placeholder={placeholder}
        className={INPUT_CLS}
        data-testid={testid}
      />
    </Field>
  </div>
);

const DateField = ({ label, value, onChange, disabled, testid }) => (
  <Field label={label}>
    <DateInput value={value} onChange={onChange} disabled={disabled} testid={testid} />
  </Field>
);

const PayerSelect = ({ value, onChange, disabled, payers, fallbackName }) => (
  <Field label="Quem fez o pagamento *">
    <select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      className={`${INPUT_CLS} bg-white`}
      data-testid="expense-payer-select"
    >
      <option value="">Selecione…</option>
      {value && !payers.some((p) => p.id === value) && (
        <option value={value}>{fallbackName || "—"}</option>
      )}
      {payers.map((p) => (
        <option key={p.id} value={p.id}>
          {p.name}
        </option>
      ))}
    </select>
  </Field>
);

const SaveButton = ({ isNew, saving, onClick }) => (
  <div className="mt-4 flex justify-end">
    <button
      data-testid={isNew ? "expense-create-btn" : "expense-save-header"}
      onClick={onClick}
      disabled={saving}
      className="inline-flex items-center gap-2 px-4 py-2 bg-[#002776] text-white text-[11px] uppercase tracking-[0.25em] hover:bg-[#001a5a] disabled:opacity-60"
    >
      {saving && <Loader2 size={14} className="animate-spin" />}
      {isNew ? "Criar rascunho" : "Salvar cabeçalho"}
    </button>
  </div>
);

export function ExpenseHeaderForm({ header, setHeader, editable, isNew, saving, onSave, payers, payerName }) {
  const disabled = !editable;
  const set = (key) => (v) => setHeader((h) => ({ ...h, [key]: v }));

  return (
    <Card className="mt-6 p-5">
      <div className="grid md:grid-cols-2 gap-4">
        <TextField label="Título *" value={header.title} onChange={set("title")} disabled={disabled}
          placeholder="Ex: Viagem SP-Brasília — reunião BCB" testid="expense-title-input" />
        <TextField label="Destino" value={header.destination} onChange={set("destination")}
          disabled={disabled} testid="expense-destination-input" />
        <DateField label="Data de ida" value={header.start_date} onChange={set("start_date")}
          disabled={disabled} testid="expense-start-date-input" />
        <DateField label="Data de volta" value={header.end_date} onChange={set("end_date")}
          disabled={disabled} testid="expense-end-date-input" />
        <PayerSelect value={header.payer_id} onChange={set("payer_id")} disabled={disabled}
          payers={payers} fallbackName={payerName} />
        <DateField label="Quando foi pago *" value={header.payment_date} onChange={set("payment_date")}
          disabled={disabled} testid="expense-payment-date-input" />
        <TextField label="A que se refere o pagamento *" value={header.payment_reference}
          onChange={set("payment_reference")} disabled={disabled} wide
          placeholder="Ex: Passagens e hospedagem da reunião no BCB" testid="expense-payment-reference-input" />
        <div className="md:col-span-2">
          <Field label="Propósito / observações">
            <textarea
              rows={3}
              value={header.purpose}
              onChange={(e) => set("purpose")(e.target.value)}
              disabled={disabled}
              className={`${INPUT_CLS} resize-y`}
              data-testid="expense-purpose-input"
            />
          </Field>
        </div>
        <TextField label="Dados bancários para reembolso" value={header.bank_info} onChange={set("bank_info")}
          disabled={disabled} wide placeholder="Banco / agência / conta / chave PIX" testid="expense-bank-info-input" />
      </div>
      {editable && <SaveButton isNew={isNew} saving={saving} onClick={onSave} />}
    </Card>
  );
}
